import { SchemaAction } from '@rossum/api-client/schemas';
import { Chip, Stack } from '@rossum/ui/material';
import { ReactNode, useRef } from 'react';
import { partition } from 'remeda';

// Left padding + right padding - 1x spacing
const PADDING = 10 + 10 - 8;

// Works for single digit number of icons in chip
// Let's hope nobody has 10+ actions
// Both include margin
const CHIP_SIZE = 32 + 8;
const ICON_SIZE = 24 + 8;

export const ActionCell = ({
  actions,
  renderAction,
  width,
}: {
  actions: SchemaAction[];
  renderAction?: (action: SchemaAction) => ReactNode;
  width?: number | undefined;
}) => {
  const numberOfIconsThatFit = width
    ? Math.floor((width - PADDING) / ICON_SIZE)
    : 0;

  const numberOfIconsThatFitIncludingChip = width
    ? Math.floor((width - PADDING - CHIP_SIZE) / ICON_SIZE)
    : 0;

  const ref = useRef<HTMLDivElement>(null);
  const [firstTwoActions, otherActions] = partition(actions, (_, index) =>
    // This makes sure you don't display chip needlessly even though the last icon would fit if there was no chip.
    actions.length <= numberOfIconsThatFit
      ? true
      : index < numberOfIconsThatFitIncludingChip
  );

  return renderAction ? (
    <Stack direction="row" spacing={1} width="100%" ref={ref}>
      {firstTwoActions.map(renderAction)}
      {otherActions.length ? (
        <Chip color="default" label={`+${otherActions.length}`} />
      ) : null}
    </Stack>
  ) : null;
};
